import {
  ChannelOptionData,
  AvatarInfoType,
} from 'src/components/Channels/ChannelSidebarItem';
import { FileChannel } from 'src/store/files/types';
import { Client, Company } from 'src/store/clients/types';

export const useChannelItemSetup = (
  clients: Client[],
  companies: Company[],
) => {
  const createChannelItemOption = (
    channel: FileChannel,
  ): ChannelOptionData | null => {
    // this is a channel that is based on members
    const { memberIDs = {} } = channel.additionalFields || {};
    const channelMemberIds = Object.keys(memberIDs).sort();
    if (!channelMemberIds.length) {
      return null;
    }

    const channelNameParts: string[] = [];
    const avatarInfo: AvatarInfoType[] = [];
    channelMemberIds.forEach(channelMemberId => {
      const client = clients.find(
        clientUser => clientUser.id === channelMemberId,
      );
      if (!client) {
        return;
      }

      channelNameParts.push(
        `${client.fields.given_name} ${client.fields.family_name}` || '',
      );

      avatarInfo.push({
        name: `${client.fields.given_name} ${client.fields.family_name}` || '',
        imageUrl: (client.fields && client.fields.picture) || '',
        fallbackColor: (client.fields && client.fields.fallbackColor) || '',
      });
    });

    if (!avatarInfo.length && !channel.fields.companyID) {
      // do not return a channel item for a non-company file channel that does not have avatar info set at this point in the method
      return null;
    }

    const channelOption: ChannelOptionData = {
      fileChannel: channel,
      position: 3,
      name: '',
      avatarInfo: [],
    };

    if (channel.fields.companyID) {
      const matchingCompany = companies.find(
        c => c.id === channel.fields.companyID,
      );
      if (!matchingCompany) {
        return null;
      }
      channelOption.name = matchingCompany.fields.name;
      channelOption.avatarInfo = [
        {
          name: matchingCompany.fields.name,
          imageUrl: matchingCompany.fields.avatarImageURL || '',
          fallbackColor: matchingCompany.fields.fallbackColor || '',
        },
      ];
    } else {
      // TODO: setup channel item to support multi-members in rendering
      channelOption.name = channelNameParts
        .filter(p => Boolean(p))
        .sort((a, b) => a.localeCompare(b))
        .join(', ');
      channelOption.avatarInfo = avatarInfo.sort((a, b) =>
        a.name.localeCompare(b.name),
      );
    }

    return channelOption;
  };

  return createChannelItemOption;
};
